import React from "react";

export default function EmptyState({ icon: Icon, title, description, action, testid = "empty-state" }) {
  return (
    <div
      className="flex flex-col items-center justify-center text-center px-8 py-16 animate-fade-up"
      data-testid={testid}
    >
      {Icon && (
        <div className="h-20 w-20 rounded-full bg-sage-50 text-sage-700 flex items-center justify-center mb-5">
          <Icon size={32} strokeWidth={1.8} />
        </div>
      )}
      <h3 className="font-display text-xl font-bold text-ink">{title}</h3>
      {description && (
        <p className="mt-2 text-sm text-muted2 max-w-[260px] leading-relaxed">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
